// VECHTSPORT KIDS READY™ — Dutch copy of MARTIAL ARTS KIDS CLASS READY™ (the winner), translated from the German copy.
// Same structure, palette and angles. Netherlands + Flanders, informal "je/jij".
// All copy and links live here. Image URLs live in data/images.ts, the pixel in data/pixel.ts.
// Promise (must match ads, checkout and the PDF): 52-week plan + 10 complete 45-minute kids classes,
// 27 € one-time, 10-day guarantee, the 5 bonuses in the checkout order.
// Values = the checkout: main 159 €; bonuses 37, 27, 27, 27, 37 € (155 €); total 314 € -> 27 €, you save 287 €.
// Terms follow productos/martial-arts-kids-nl/glosario.md. Lesson, game, drill, quarter and page names match the
// Dutch Gamma prompt (prompts/martial-arts-kids-class-ready-nl.md).
// Kids + contact sport: no promises about self-defense, belts or sign-ups; pads and air only, no sparring; no testimonials.
// ­ = soft hyphen, so long Dutch words can break on a 375 px screen.

export { META_PIXEL_ID } from './pixel';
export const CHECKOUT_URL = 'https://vechtsport-kids-ready.impultienda.ar/checkout';

export const PAGE_TITLE = 'Vechtsport Kids Ready™ – Je hele jaar kinderlessen, kant-en-klaar gepland';
export const META_DESCRIPTION =
  'Een jaarplan van 52 weken plus 10 complete kinderlessen van 45 minuten, direct te geven. Sla de pagina van de week open, bereid je 5 minuten voor en geef vandaag nog de les.';

// GLOBAL
export const brand = 'VECHTSPORT KIDS READY™';
/** Label for every button that scrolls to the offer section */
export const ctaLabel = 'PLAN MIJN HELE JAAR';
export const ctaMicrocopy = 'Direct als pdf · Eenmalig 27 € · 10 dagen garantie';
export const stickyLabel = 'PLAN MIJN JAAR · 27 €';
export const topBarMobileLabel = 'HET BOEK · 27 €';
export const price = '27 €';

// 1. HERO (buyer line, title, short subtitle, mockup, button)
export const hero = {
  eyebrow: 'VOOR TRAINERS IN KARATE, TAEKWONDO, KICKBOKSEN EN THAIBOKSEN',
  titleLead: 'JE HELE JAAR KINDER­LESSEN,',
  titleHighlight: 'KANT-EN-KLAAR GEPLAND.',
  sub: 'Een jaarplan van 52 weken plus 10 complete kinderlessen van 45 minuten, direct te geven. Sla de pagina van de week open en geef vandaag nog de les.',
  mockupAlt: 'Vechtsport Kids Ready™ op een computerscherm, met de 5 bonussen op tablets en smartphones',
};

// 2. STATS
export const stats = [
  { value: '52', label: 'WEKEN GEPLAND' },
  { value: '10', label: 'COMPLETE LESSEN' },
  { value: '45', label: 'MINUTEN MET TIJDSCHEMA' },
  { value: '3', label: 'LEEFTIJDSNIVEAUS IN ELKE LES' },
];

// 2b. BEFORE / AFTER
export const beforeAfter = {
  title: 'DE AVOND ERVOOR VS. OP DE MAT.',
  before: {
    label: 'VOOR',
    when: 'De avond ervoor',
    quote: '“Wat doe ik vanavond met de kinderen?”',
    items: ['Oefeningen bij elkaar zoeken in filmpjes.', 'Weer dezelfde stootoefening.', 'De kleintjes haken af, de groten vervelen zich.'],
  },
  after: {
    label: 'NA',
    when: 'Op de mat',
    items: ['Pagina van de week openslaan.', 'In 5 minuten voorbereiden.', 'Het lesblok van 45 minuten geven.', 'Afgroeten en de ouderinfo versturen.'],
  },
};

// 3. WHAT DOES YOUR CLASS NEED THIS WEEK (pick a need, see the class that is ready for it)
const block = 'Lesblok: groeten & opwarmspel 8 · techniek 12 · pad- & partneroefeningen 12 · eindspel 8 · cooling-down & waardemoment 5';
export const selector = {
  eyebrow: 'BEGIN WAAR JE KINDEREN NU STAAN',
  title: 'WAT HEEFT JE LES DEZE WEEK NODIG?',
  sub: 'Kies een thema en bekijk de les die er al klaar voor is.',
  startLabel: 'JE VOLGENDE LES',
  tablistLabel: 'Lesthema’s',
  columns: ['PAGINA 1 · LESPLAN', 'PAGINA 2 · ZO LEG JE HET UIT', 'PAGINA 3 · OEFENINGEN & SPEL'],
  note: 'Alle 10 lessen hebben dezelfde opbouw van 3 pagina’s. Stem elke les af op jouw stijl en de veiligheidsregels van jouw dojo.',
  items: [
    {
      tab: 'Een sterke start: houding & respect',
      n: 'LES 01 · WEEK 1',
      title: 'Houding, dekking & respect in de dojo',
      goal: 'Het kind groet, staat in een stabiele vechthouding met een hoge dekking en gaat op commando terug naar de klaarhouding.',
      open: ['Lesdoel, materiaal en voorbereiding in 5 minuten', 'Je openingswoorden: “Voeten uit elkaar, één voet naar achteren. Handen hoog bij je gezicht. Dat is je dekking!”', block],
      activity: ['5 techniekstappen met de belangrijke punten: in de houding, de groet, klaarhouding, vechthouding, dekking', '3 kaarten “Zo verbeter je het”, zoals “Treinrails, geen koord!”', 'Kaart leeftijdsniveau: zo werkt het met 4–6, 7–9 en 10–12 jaar'],
      close: ['2 oefeningen met matschets: Houdingscontrole en Veren & bevriezen', 'Eindspel: De dojo zegt', 'Waardemoment (Respect), ouderinfo en streepjescheck'],
    },
    {
      tab: 'Trappen met balans',
      n: 'LES 03 · WEEK 9',
      title: 'Frontkick & balans',
      goal: 'Het kind brengt de knie omhoog, trapt met de bal van de voet naar voren en zet de voet gecontroleerd neer in de houding.',
      open: ['Lesdoel, materiaal en voorbereiding in 5 minuten', 'Je openingswoorden: “Knie omhoog … trap … knie terug … voet neer. De dekking blijft hoog!”', block],
      activity: ['Techniekstappen met de belangrijke punten, van knie omhoog tot voet neer', '3 kaarten “Zo verbeter je het” voor de meest gemaakte fouten bij het trappen', 'Kaart leeftijdsniveau voor 4–6, 7–9 en 10–12 jaar'],
      close: ['2 oefeningen op het trapkussen, met matschets en tijden', 'Eindspel: Stoplicht', 'Waardemoment (Zelfbeheersing), ouderinfo en streepjescheck'],
    },
    {
      tab: 'Combinaties op de pads',
      n: 'LES 06 · WEEK 22',
      title: 'Stoot­combinaties op de pads',
      goal: 'Het kind stoot een combinatie van 3 (jab, cross, hoek) op de pads en gaat terug in dekking.',
      open: ['Lesdoel, materiaal en voorbereiding in 5 minuten', 'Je openingswoorden: “1 is jab, 2 is cross, 3 is hoek. Klaar? 1-2-3 … dekking!”', block],
      activity: ['Techniekstappen voor de hoek en de 1-2-3', 'Hoe de groten de pads veilig vasthouden voor een partner', 'Kaart leeftijdsniveau voor 4–6, 7–9 en 10–12 jaar'],
      close: ['2 padoefeningen met matschets, rondes en tijden', 'Eindspel: Combinatieketting', 'Waardemoment (Samenwerking), ouderinfo en streepjescheck'],
    },
    {
      tab: 'Veiligheid & bevrijden uit grepen',
      n: 'LES 09 · WEEK 35',
      title: 'Bevrijden uit grepen & veilig bij vreemden',
      goal: 'Het kind bevrijdt zich uit een zachte polsgreep, stapt naar achteren, gebruikt een sterke stem en weet dat het daarna naar een vertrouwde volwassene rent om te vertellen wat er gebeurd is.',
      open: ['Lesdoel, materiaal en voorbereiding in 5 minuten', 'Je openingswoorden: lostrekken, naar achteren stappen, sterke stem, naar een vertrouwde volwassene rennen', block],
      activity: ['Eenvoudige bevrijdingsstappen, langzaam en zacht geoefend', 'De veiligheidsregels: bij je groep blijven, je stem gebruiken, het vertellen aan een volwassene die je vertrouwt', 'Kaart leeftijdsniveau voor 4–6, 7–9 en 10–12 jaar'],
      close: ['2 rustige oefeningen met matschets', 'Eindspel: Estafette met sterke stem', 'Waardemoment (Veiligheid), ouderinfo en streepjescheck'],
    },
  ],
};

// 4. LOOK INSIDE (real pages of the book, in the same order as pageImages in data/images.ts)
export const lookInside = {
  eyebrow: 'ECHTE PAGINA’S. BEKIJK DE OPMAAK VOORDAT JE KOOPT.',
  title: 'DIT LIGT VOORTAAN NAAST JE MAT.',
  sub: 'Open elke pagina op ware grootte: je jaarplan van 52 weken, een lesplan, de uitleg en de oefeningen van een les, de generale repetitie voor het bandexamen en je lesplanner.',
  hint: 'Veeg voor meer · Tik op een pagina om hem groot te bekijken',
  note: 'Dit zijn geselecteerde pagina’s, niet het hele boek.',
  captions: [
    'Je jaarplan van 52 weken (kwartaal 3)',
    'Les 05 · Lesplan',
    'Les 02 · Zo leg je het uit',
    'Les 02 · Oefeningen & spel',
    'Les 10 · Generale repetitie bandexamen',
    'Lesplanner + streepjesoverzicht',
  ],
};

// 5. THE SYSTEM
export const plan = {
  eyebrow: 'ÉÉN SYSTEEM VOOR ELKE LES',
  title: 'HET HELE JAAR IS GEPLAND. JIJ GROET EN GEEFT LES.',
  text: 'Elke week van het jaar is gepland: de start van een van de 10 complete lessen, een kant-en-klaar spel of oefening van 10 minuten, of een streepjescheck. Elke les geeft je op 3 pagina’s het lesplan, de techniekstappen en de oefeningen met spel.',
  steps: [
    { title: 'OPENSLAAN', text: 'Zoek deze week op in je jaarplan van 52 weken.' },
    { title: 'VOOR­BEREIDEN', text: 'Lees de pagina en zet de mat in 5 minuten klaar.' },
    { title: 'LESGEVEN', text: 'Opwarmspel, één techniek, pads en partners.' },
    { title: 'AFGROETEN', text: 'Eindspel, waardemoment en de ouderinfo.' },
  ],
  featuresTitle: 'IN ELKE COMPLETE LES',
  features: [
    { icon: 'goal', title: 'Eén duidelijk lesdoel', text: 'Eén zin over wat de kinderen gaan doen, de startweek en welke voorkennis ze nodig hebben.' },
    { icon: 'timer', title: 'Een lesblok van 45 minuten', text: 'Groeten & opwarmspel 8 · Techniek 12 · Pad- & partneroefeningen 12 · Eindspel 8 · Cooling-down & waardemoment 5.' },
    { icon: 'steps', title: 'Techniekstappen + aanwijzingen', text: 'Genummerde stappen met de belangrijke punten, en precies de aanwijzing waarmee je de meest gemaakte fouten verbetert.' },
    { icon: 'questions', title: '4–6, 7–9 en 10–12 jaar', text: 'Zo geef je dezelfde les aan elke leeftijd op je mat, ook in gemengde groepen.' },
    { icon: 'quote', title: 'Je woorden, letterlijk', text: 'Openingswoorden, commando’s en het waardemoment, plus een pro-tip en een veelgemaakte fout.' },
    { icon: 'action', title: 'Oefeningen, spel + ouderinfo', text: '2 oefeningen en een eindspel met matschets, een streepjescheck en ouderinfo om direct te versturen.' },
  ],
} as const;

// 5b. VALUES + AGE LEVELS
export const valuesBand = {
  eyebrow: 'MEER DAN TRAPPEN EN STOTEN',
  title: 'EEN WAARDE VOOR ELKE LES. HET HELE JAAR.',
  sub: 'Elke les eindigt met een kort waardemoment, letterlijk uitgeschreven, zodat ouders zien wat hun kinderen mee naar huis nemen.',
  classWord: 'LES',
  values: [
    { n: '01', value: 'Respect' },
    { n: '02', value: 'Concen­tratie' },
    { n: '03', value: 'Zelf­beheersing' },
    { n: '04', value: 'Doorzettings­vermogen' },
    { n: '05', value: 'Zelf­vertrouwen' },
    { n: '06', value: 'Samen­werking' },
    { n: '07', value: 'Oplettend­heid' },
    { n: '08', value: 'Moed' },
    { n: '09', value: 'Veiligheid' },
    { n: '10', value: 'Discipline' },
  ],
  agesTitle: 'ELKE LES PAST ZICH AAN DE KINDEREN VOOR JE AAN',
  ages: [
    { age: '4–6 JAAR', text: 'Vloermarkeringen, dierennamen, korte stappen die ze hardop meezeggen en veel spellen.' },
    { age: '7–9 JAAR', text: 'De hele techniek op de pads van de trainer, op commando van kant wisselen.' },
    { age: '10–12 JAAR', text: 'Meer tempo, bewegen met de dekking hoog, de pads vasthouden voor een partner en helpen de les te leiden.' },
  ],
};

// 6. THE 52-WEEK PLAN (quarter names as printed in the book)
export const yearPlan = {
  eyebrow: 'JE JAARPLAN VAN 52 WEKEN',
  title: 'HET HELE JAAR, WEEK VOOR WEEK GEPLAND.',
  sub: 'In de ★-weken start een nieuwe les. De ◆-weken zijn streepjeschecks. In de weken daartussen wacht een kant-en-klaar spel of oefening van 10 minuten.',
  weekWord: 'WEEK',
  quarters: [
    {
      q: 'Q1',
      weeks: 'WEKEN 1–13',
      name: 'DE BASIS LEGGEN',
      full: [
        { week: '1', label: 'START LES 01', title: 'Houding, dekking & respect in de dojo' },
        { week: '5', label: 'START LES 02', title: 'Rechte stoten: jab & cross' },
        { week: '9', label: 'START LES 03', title: 'Frontkick & balans' },
        { week: '13', label: 'STREEPJESCHECK', title: 'Voortgang controleren met de lesplanner', review: true },
      ],
      activities: '+ kant-en-klare spellen en oefeningen van 10 minuten, zoals Standbeeld in dekking, Opstellen tegen de klok en Staan als een flamingo.',
    },
    {
      q: 'Q2',
      weeks: 'WEKEN 14–26',
      name: 'TREFFEN & VERDEDIGEN',
      full: [
        { week: '14', label: 'START LES 04', title: 'Rondtrap' },
        { week: '18', label: 'START LES 05', title: 'Blokken: hoog, midden & laag' },
        { week: '22', label: 'START LES 06', title: 'Stoot­combinaties op de pads' },
        { week: '26', label: 'STREEPJESCHECK', title: 'Voortgang controleren met de lesplanner', review: true },
      ],
      activities: '+ kant-en-klare spellen en oefeningen van 10 minuten, zoals De draaiklok, Regenblok en Roep de combinatie.',
    },
    {
      q: 'Q3',
      weeks: 'WEKEN 27–39',
      name: 'BEWEGEN & VEILIG BLIJVEN',
      full: [
        { week: '27', label: 'START LES 07', title: 'Voetenwerk & afstand' },
        { week: '31', label: 'START LES 08', title: 'Veilig vallen' },
        { week: '35', label: 'START LES 09', title: 'Bevrijden uit grepen & veilig bij vreemden' },
        { week: '39', label: 'STREEPJESCHECK', title: 'Voortgang controleren met de lesplanner', review: true },
      ],
      activities: '+ kant-en-klare spellen en oefeningen van 10 minuten, zoals “Te dichtbij, te ver”, Schommelstoel en Veilige zone.',
    },
    {
      q: 'Q4',
      weeks: 'WEKEN 40–52',
      name: 'ALLES SAMENBRENGEN',
      full: [
        { week: '40', label: 'START LES 10', title: 'Generale repetitie voor het bandexamen' },
        { week: '52', label: 'STREEPJESCHECK', title: 'Streepjescheck aan het einde van het jaar', review: true },
      ],
      activities: '+ kant-en-klare spellen en oefeningen van 10 minuten, zoals Blokmeester, Het podium op en Dojo-estafette.',
    },
  ],
  toolsTitle: 'PLUS JE GEREEDSCHAP ALS TRAINER',
  tools: ['Als de les moeilijk wordt: 8 situaties, wat je zegt en wat je doet', 'Lesplanner + streepjesoverzicht: plan elke les in 5 minuten', 'Spiekkaart om naast de mat te leggen'],
};

// 7. THE 10 COMPLETE CLASSES
export const meetings = {
  eyebrow: 'DE 10 COMPLETE LESSEN',
  title: 'TIEN KINDERLESSEN. DIRECT TE GEVEN.',
  sub: 'Volg het jaarplan van 52 weken of begin met de les die je kinderen nu nodig hebben. Elke les heeft 3 pagina’s: lesplan, zo leg je het uit, oefeningen & spel.',
  weekLabel: 'STARTWEEK',
  items: [
    { n: '01', week: '1', title: 'Houding, dekking & respect in de dojo', goal: 'Groeten, een stabiele vechthouding met een hoge dekking en op commando de klaarhouding.' },
    { n: '02', week: '5', title: 'Rechte stoten: jab & cross', goal: 'Jab en cross vanuit de dekking, met de hand elke keer terug bij het gezicht.' },
    { n: '03', week: '9', title: 'Frontkick & balans', goal: 'Knie omhoog, trappen met de bal van de voet en gecontroleerd neerkomen in de houding.' },
    { n: '04', week: '14', title: 'Rondtrap', goal: 'De standvoet indraaien, de knie zijwaarts omhoog en gecontroleerd trappen op een laag of middelhoog doel.' },
    { n: '05', week: '18', title: 'Blokken: hoog, midden & laag', goal: 'Drie blokken op commando, met de ogen op de trainer.' },
    { n: '06', week: '22', title: 'Stoot­combinaties op de pads', goal: 'Een combinatie van 3 stoten (jab, cross, hoek) op de pads en terug in dekking.' },
    { n: '07', week: '27', title: 'Voetenwerk & afstand', goal: 'Naar voren, naar achteren en opzij bewegen zonder de voeten te kruisen, en de juiste afstand vinden.' },
    { n: '08', week: '31', title: 'Veilig vallen', goal: 'Vanuit een lage positie naar achteren en opzij vallen, kin op de borst, en veilig opstaan.' },
    { n: '09', week: '35', title: 'Bevrijden uit grepen & veilig bij vreemden', goal: 'Je bevrijden uit een zachte polsgreep, de sterke stem gebruiken en naar een vertrouwde volwassene rennen.' },
    { n: '10', week: '40', title: 'Generale repetitie voor het bandexamen', goal: 'Een rustig proefexamen met de technieken van het jaar, een beoordelingsblad en de tekst voor de ceremonie.' },
  ],
  cta: 'HAAL ALLE 10 LESSEN + 5 BONUSSEN',
  ctaMicrocopy: '27 € · Eenmalige betaling',
};

// 8. BONUSES (same order and values as the checkout)
export const bonuses = {
  eyebrow: '5 BONUSSEN INBEGREPEN BIJ JE BOEK VAN 27 €',
  title: 'ALLES WAT JE KINDERLESSEN VERDER NOG NODIG HEBBEN.',
  sub: 'Spellen, bandexamens, berichten voor ouders, padoefeningen en een plan voor de proefles, direct te gebruiken.',
  valueWord: 'WAARDE',
  free: 'GRATIS',
  coverWord: 'Omslag',
  totalNote: '155 € aan bonussen, gratis erbij',
  items: [
    {
      label: 'BONUS 01',
      value: '37 €',
      short: '60 vechtsportspellen voor kinderen',
      hook: 'Nooit meer zonder spelideeën.',
      title: '60 vechtsport­spellen voor kinderen – helemaal zonder materiaal',
      text: '60 leuke, veilige spellen om elke les mee te openen, energie kwijt te raken en af te sluiten, gesorteerd op doel: opwarmen, reactie, balans, concentratie, trappen en stoten, samenwerking en cooling-down. Elk met opstelling, regels, duur en een veiligheidstip.',
    },
    {
      label: 'BONUS 02',
      value: '27 €',
      short: 'Bandexamen-kit',
      hook: 'Rustige, goed georganiseerde bandexamens.',
      title: "Bandexamen-kit – eisen, examenschema & diploma's om te printen",
      text: "Een voorbeeldchecklist met de eisen voor elke band (aan te passen aan je stijl), een beoordelingsblad, een examenschema met tijden, wat je zegt bij de opening en de afsluiting, een streepjesoverzicht en diploma's om te printen.",
    },
    {
      label: 'BONUS 03',
      value: '27 €',
      short: 'Ouder-communicatiepakket',
      hook: 'Je weet precies wat je naar de gezinnen stuurt.',
      title: 'Ouder-communicatie­pakket – welkomstbrief, dojoregels & kant-en-klare berichten',
      text: 'Een welkomstbrief voor nieuwe kinderen, dojoregels voor kinderen op één pagina, een checklist “Wat neem ik mee?”, aankondigingen voor bandexamens, een maandelijks bericht over de waarde van de maand, berichten bij gemiste lessen en handleidingen voor rustige gesprekken met ouders.',
    },
    {
      label: 'BONUS 04',
      value: '27 €',
      short: '50 pad- & partneroefeningen',
      hook: 'Elke les nieuw werk op de pads.',
      title: '50 pad- & partner­oefeningen – voor elke kinderles',
      text: '50 oefeningen met pads, trapkussens en partners voor stoten, trappen, blokken, combinaties, voetenwerk en reactie. Elk met opstelling, rondes en tijden, hoe je de pads vasthoudt en een veiligheidstip.',
    },
    {
      label: 'BONUS 05',
      value: '37 €',
      short: 'De proefles-gids',
      hook: 'Zodat elke eerste les telt.',
      title: 'De proefles-gids – een eerste les die kinderen en ouders niet vergeten',
      text: 'Hoe je het gezin bij de deur verwelkomt, een proefles van 30 minuten met spellen en een eerste techniek die elk kind kan, wat je aan het einde zegt en kant-en-klare berichten voor de dagen erna.',
    },
  ],
};

// 9. OFFER
export const offer = {
  eyebrow: 'JE VOLGENDE LES BEGINT HIER',
  title: 'JE HELE JAAR KINDERLESSEN. IN ÉÉN BOEK.',
  kicker: 'HET COMPLETE DIGITALE BOEK',
  name: 'Vechtsport Kids Ready™',
  description: 'Een jaarplan van 52 weken en 10 complete kinderlessen van 45 minuten, direct te geven, plus vijf bonussen: spellen, een bandexamen-kit, berichten voor ouders, padoefeningen en een gids voor de proefles.',
  mockupAlt: 'Alles wat in Vechtsport Kids Ready™ zit',
  includedTitle: 'JE BOEK BEVAT',
  included: [
    'Jaarplan van 52 weken: het hele jaar gepland',
    '10 complete kinderlessen van elk 3 pagina’s',
    'Een lesblok van 45 minuten met tijden in elke les',
    'Techniekstappen, belangrijke punten en aanwijzingen bij fouten',
    '4–6, 7–9 en 10–12 jaar in elke les',
    'Oefeningen, eindspel, waardemoment en ouderinfo',
    'Gereedschap als trainer: lastige momenten, lesplanner, spiekkaart',
  ],
  /** Value stack: exactly the checkout prices (EUR) */
  stackTitle: 'DIT KRIJG JE ALLEMAAL',
  mainItem: { label: 'Vechtsport Kids Ready™ (jaarplan van 52 weken + 10 complete lessen)', value: '159 €' },
  totalLabel: 'Totale waarde',
  totalValue: '314 €',
  todayLabel: 'VANDAAG',
  priceNote: 'Eenmalige betaling · Zo’n 52 cent per week',
  saveNote: 'Je bespaart 287 €',
  /** The ONLY button that goes to checkout */
  cta: 'JA, STUUR ME HET BOEK – 27 €',
  ctaNote: ['Door naar veilig afrekenen', 'Toegang per e-mail na de betaling'],
  format: 'Pdf in het Nederlands. Digitale levering. Stem elke les af op jouw stijl, de veiligheidsregels van jouw dojo en de leeftijd en het niveau van jouw kinderen.',
  guaranteeNote: '10 dagen niet-goed-geld-terug-garantie',
};

// 10. GUARANTEE
export const guarantee = {
  sealTop: '10',
  sealBottom: 'DAGEN GELD TERUG',
  title: '10 DAGEN NIET GOED, GELD TERUG. ZONDER VRAGEN.',
  text: 'Geef je volgende lessen ermee. Is het toch niets voor jou? Mail dan binnen 10 dagen na je aankoop naar support@stockdigital.shop en je krijgt je geld terug.',
};

// 11. FAQ
export const faq = {
  eyebrow: 'JE WEET PRECIES WAT JE KRIJGT',
  title: 'EEN PAAR VRAGEN VOORDAT JE DE MAT OPGAAT.',
  sub: 'Gemaakt voor trainers en eigenaren van een vechtsportschool die kinderen lesgeven. Een kant-en-klaar lesboek, geen videocursus.',
  items: [
    {
      q: 'Wat is dit product precies?',
      a: 'Een pdf-boek in het Nederlands: een jaarplan van 52 weken (elke week heeft de start van een les, een kant-en-klaar spel of oefening van 10 minuten, of een streepjescheck) en 10 complete kinderlessen van 45 minuten van elk 3 pagina’s, plus je gereedschap als trainer en 5 bonussen.',
    },
    {
      q: 'Voor welke stijlen is het geschikt?',
      a: 'Voor stijlen met stoten en trappen die aan kinderen worden geleerd: karate, taekwondo, kickboksen, thaiboksen en gemengde programma’s. De technieken hebben algemene namen (frontkick, jab, hoog blok), en elke les herinnert je eraan om de namen, de etiquette en de bandvolgorde van jouw stijl te gebruiken.',
    },
    {
      q: 'Voor welke leeftijd is het?',
      a: 'Voor kinderen van ongeveer 4 tot 12 jaar. Elke les heeft een kaart leeftijdsniveau voor 4–6, 7–9 en 10–12 jaar, zodat het ook in gemengde groepen werkt.',
    },
    {
      q: 'Wordt er gespard of contact gemaakt?',
      a: 'Er wordt niet gespard. De kinderen stoten en trappen op pads, doelen en in de lucht. Partneroefeningen alleen met licht, gecontroleerd contact op de pads en altijd onder toezicht. Vallen wordt alleen op matten geoefend, vanuit een lage positie.',
    },
    {
      q: 'Leren de kinderen zelfverdediging in de veiligheidsles?',
      a: 'Les 09 leert eenvoudige, zachte bevrijdingen uit grepen en veiligheidsregels: bij je groep blijven, een sterke stem gebruiken en het vertellen aan een volwassene die je vertrouwt. Het is geen belofte dat een kind zich in elke situatie kan verdedigen.',
    },
    {
      q: 'Hoe krijg ik het?',
      a: 'Na de betaling krijg je de toegang op het e-mailadres dat je bij het afrekenen invult. Er wordt niets opgestuurd. Gebruik een e-mailadres waar je bij kunt en kijk zo nodig in je spammap.',
    },
    {
      q: 'Kan ik de lessen los gebruiken?',
      a: 'Ja. Elke les werkt op zichzelf: je kunt beginnen met de les die je kinderen nu nodig hebben, of het jaarplan van 52 weken vanaf week 1 volgen.',
    },
    {
      q: 'Kan ik het printen?',
      a: 'Ja. De pagina’s zijn goed te lezen op je telefoon of tablet naast de mat, en de lesplanner en het streepjesoverzicht zijn klaar om te printen.',
    },
    {
      q: 'Mag ik het delen met mijn trainers?',
      a: 'Deze aankoop is voor je eigen gebruik als trainer. Delen met meerdere scholen, verspreiden of doorverkopen valt niet onder dit aanbod.',
    },
    { q: 'Is het een abonnement?', a: 'Nee. Je betaalt één keer 27 €.' },
    { q: 'Hoe werkt de garantie?', a: 'Je hebt 10 dagen de tijd om je geld terug te vragen, zonder gedoe.' },
  ],
};

// 12. FINAL CTA
export const finalCta = {
  eyebrow: 'VOOR DE VOLGENDE KEER “WAT DOE IK VANAVOND MET DE KINDEREN?”',
  title: 'STAP VANDAAG DE MAT OP MET EEN KANT-EN-KLARE LES.',
  text: 'Sla de pagina van de week open. Bereid je 5 minuten voor. Geef een les waar de kinderen graag voor terugkomen.',
  microcopy: 'Jaarplan van 52 weken + 10 complete lessen + 5 bonussen · 27 €, eenmalige betaling',
};

// 13. FOOTER
export const footer = {
  line: 'VECHTSPORT KIDS READY™ · Lesmateriaal voor trainers. Houd je altijd aan de regels van jouw stijl en de veiligheidsregels van jouw dojo.',
  supportLabel: 'Klantenservice:',
  supportEmail: 'support@stockdigital.shop',
  copyright: '© 2026',
};
